// TypeScript exposes ES2023 APIs, but Vite emits for the ES2022 browser baseline.
// Remove these polyfills when the build target supports the APIs natively.
// oxlint-disable-next-line no-unused-vars
interface ObjectConstructor {
  groupBy<T, K extends PropertyKey>(
    items: Iterable<T>,
    keySelector: (item: T, index: number) => K
  ): Partial<Record<K, T[]>>;
}

if (!Array.prototype.toSorted) {
  // oxlint-disable-next-line no-extend-native
  Object.defineProperty(Array.prototype, 'toSorted', {
    // oxlint-disable-next-line consistent-function-scoping
    value: function toSorted<T>(this: T[], compareFn?: (a: T, b: T) => number): T[] {
      const copy = this.slice();
      // oxlint-disable-next-line no-array-sort
      return copy.sort(compareFn);
    },
    writable: true,
    configurable: true,
  });
}

if (!Array.prototype.toReversed) {
  // oxlint-disable-next-line no-extend-native
  Object.defineProperty(Array.prototype, 'toReversed', {
    // oxlint-disable-next-line consistent-function-scoping
    value: function toReversed<T>(this: T[]): T[] {
      const copy = this.slice();
      // oxlint-disable-next-line no-array-reverse
      return copy.reverse();
    },
    writable: true,
    configurable: true,
  });
}

if (!Object.groupBy) {
  Object.defineProperty(Object, 'groupBy', {
    // oxlint-disable-next-line consistent-function-scoping
    value: function groupBy<T, K extends PropertyKey>(
      items: Iterable<T>,
      keySelector: (item: T, index: number) => K
    ): Partial<Record<K, T[]>> {
      const result = Object.create(null) as Record<K, T[]>;
      let index = 0;
      for (const item of items) {
        const key = keySelector(item, index++);
        (result[key] ??= []).push(item);
      }
      return result;
    },
    writable: true,
    configurable: true,
  });
}

if (!Array.prototype.with) {
  // oxlint-disable-next-line no-extend-native
  Object.defineProperty(Array.prototype, 'with', {
    // oxlint-disable-next-line consistent-function-scoping
    value: function withAt<T>(this: T[], index: number, value: T): T[] {
      const length = this.length;
      const relativeIndex = index < 0 ? length + index : index;
      if (relativeIndex < 0 || relativeIndex >= length) {
        throw new RangeError(`Invalid index: ${index}`);
      }
      const copy = this.slice();
      copy[relativeIndex] = value;
      return copy;
    },
    writable: true,
    configurable: true,
  });
}

if (!Array.prototype.findLastIndex) {
  // oxlint-disable-next-line no-extend-native
  Object.defineProperty(Array.prototype, 'findLastIndex', {
    // oxlint-disable-next-line consistent-function-scoping
    value: function findLastIndex<T>(
      this: T[],
      predicate: (value: T, index: number, array: T[]) => unknown,
      thisArg?: unknown
    ): number {
      for (let index = this.length - 1; index >= 0; index--) {
        if (predicate.call(thisArg, this[index] as T, index, this)) {
          return index;
        }
      }
      return -1;
    },
    writable: true,
    configurable: true,
  });
}
